module.exports = __webpack_public_path__ + "img/search.6328cf28.svg";